import React from 'react';
import { Tabs } from 'antd';
import SettingsDropdowns from '../../containers/PaidMedia.js/SettingsDropdowns';
import Reporting from '../../containers/PaidMedia.js/Reporting';

function Reddit() {

    const tabs = [
        {
            label: 'Settings',
            key: 'Settings',
            children: [<SettingsDropdowns platform='reddit'></SettingsDropdowns>]
        },
        {
            label: 'Reporting',
            key: 'Reporting',
            children: [<Reporting platform='reddit'></Reporting>]
        }
    ]

    return (
        <div>
            <Tabs style={{
                'width': '80vw',
                'marginLeft': '1vw',
            }} items={tabs} defaultActiveKey='Reporting' ></Tabs>
        </div>
    );
}

export default Reddit;
